import React from 'react';
import { Row } from '@thd-olt-component-react/grid';
import { Metadata } from '@thd-olt-component-react/metadata';
import { Typography } from '@one-thd/sui-atomic-components';
import { PreSelectedFilterList, getFiltersFromURL } from '@thd-olt-component-react/gift-cards-list';
import { GiftCardMaintenanceAlert, useDisabledGiftCardFlow } from '@thd-olt-component-react/gift-cards-information';
import { staticPageUrls, FEATURE_SWITCH_NAMES } from '../utils/consts';
import Breadcrumbs from '../components/breadcrumbs/Breadcrumbs';

export const List = () => {
  const params = getFiltersFromURL();
  const filterType = Object.keys(params).length > 0 ? Object.keys(params)[0] : '';
  const filterName = params[filterType]?.[0] || '';
  const pageTitle = `${filterName} ${staticPageUrls.list.name}`;

  const metaData = {
    alternateUrlEn: 'https://www.homedepot.com/gift-cards/list',
    alternateUrlEnCa: 'https://www.homedepot.ca/en/home/gift-cards.html',
    alternateUrlFrCa: 'https://www.homedepot.ca/fr/accueil/cartes-cadeaux.html',
    // canonicalURL: pathname,
    description: 'Shop for the Home Depot gift card and make shopping for home improvement easier than ever. '
    + 'Free delivery on traditional gift cards, personalized e-gift cards to suit any occasion. '
    + 'Get discounts on bulk orders today!',
    facebookAdmins: '100005416960152',
    siteName: 'The Home Depot',
    title: 'Buy Gift Card - ' + pageTitle,
    type: 'Content',
  }
  const { isFlowDisabled } = useDisabledGiftCardFlow(FEATURE_SWITCH_NAMES.DISABLE_GIFT_CARD_PURCHASE);
  return (
    <>
      <Row className="sui-max-w-screen-2xl sui-m-auto" data-testid="internal-list-container">
        <Metadata data={metaData} />
        <div className="sui-mt-6 sui-ml-3">
          <Breadcrumbs
            startFromHome
            breadcrumbs={[
              staticPageUrls.landing,
              {
                name: pageTitle,
                shouldLastCrumbBeLinkable: false
              }]}
          />
        </div>
        <div className="sui-w-full sui-p-2 sui-mb-8">
          <Typography variant="h1" weight="display">
            {pageTitle}
          </Typography>
        </div>
        {isFlowDisabled ? <GiftCardMaintenanceAlert /> : <PreSelectedFilterList />}
      </Row>
    </>
  );
};

List.displayName = 'GiftCardsPage';
